import React from 'react'

import { TextField } from './../../default'

const FormText = ({ id, text, fkProps, number, password, disabled, ...rest }) => {

  const handleChange = evt => {
    if (!disabled)
      fkProps.handleChange(evt)
  }

  let type = password ? 'password' : number ? 'number' : 'string'

  return (
    <TextField
      id={id}
      label={text}
      type={type}
      helperText={fkProps.touched[id] ? fkProps.errors[id] : ""}
      error={fkProps.touched[id] && Boolean(fkProps.errors[id])}
      value={fkProps.values[id]}
      onChange={handleChange}
      onBlur={fkProps.handleBlur}
      disabled={disabled}

      {...rest}
    />
  )
}

export default FormText